import { render, staticRenderFns } from "./LoadSubmit.vue?vue&type=template&id=26af6558"
import script from "./LoadSubmit.vue?vue&type=script&lang=js"
export * from "./LoadSubmit.vue?vue&type=script&lang=js"
import style0 from "./LoadSubmit.vue?vue&type=style&index=0&id=26af6558&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports